import React, {useEffect, useRef, useState} from "react";

import {
    BadgeList,
    BannerCarousel,
    BaseContent, BetbyBanner,
    GameListSection,
    GameSpotlight, GamesSliderProps,
    HeroBannerTwoColumns,
    InfoPageAccordion,
    PageSection,
    PanelSection,
    SectionBoxes,
    StyledTextList
} from "../../contenful/types";
import PageSectionComponent from "./PageSectionComponent";
import SectionBoxesComponent from "./SectionBoxesComponent";
import InfoPageAccordionComponent from "../../ui/InfoPageAccordionComponent";
import GameListSectionComponent, {CategoryGameListSectionComponent} from "./GameListSectionComponent";
import GameSpotlightComponent from "./GameSpotlightComponent";
import {WindowSize} from "../../settings/SettingsReducer";
import {HeroBannerTwoColumnsComponent} from "./HeroBannerTwoColumnsComponent";
import {StyledTextListComponent} from "./StyledTextListComponent";
import PanelSectionComponent from "./PanelSectionComponent";
import Badges from '../../promopage/Badges';
import {CarouselPanelComponent} from "./CarouselPanelComponent";
import {useDispatch} from "react-redux";
import {BannerCarouselComponent} from "../BannerCarouselComponent";
import {BetByBannerWrapper} from "./BetbyBannerSectionComponent";
import {GamesSlider} from "./GamesSlider";

export enum DynamicContentEnum {
    PAGESECTION = "pageSection",
    SECTIONBOXES = "sectionBoxes",
    INFOPAGEACCORDION = "infoPageAccordion",
    GAMELISTSECTION = "gameListSection",
    GAMESPOTLIGHT = "gameSpotlight",
    HERO_BANNER_TWO_COLUMNS = "heroBannerTwoColumns",
    STYLED_TEXT_LIST = "styledTextList",
    BADGELIST = "badgeList",
    PANEL_SECTION = "panelSection",
    BANNER_CAROUSEL = "bannerCarousel",
    BETBY_BANNER = "betbyBanner",
    GAMESLIDER = "gameSlider",
}
export const STRAPI_DYNAMIC_CONTENT_MAP = [
    { dynamic : DynamicContentEnum.BANNER_CAROUSEL, strapi : "general.banner-carousel"},
    { dynamic : DynamicContentEnum.SECTIONBOXES, strapi : "general.section-boxes"},
    { dynamic : DynamicContentEnum.GAMELISTSECTION, strapi : "casino.game-list-section"},
    { dynamic : DynamicContentEnum.GAMESPOTLIGHT, strapi : "casino.game-spotlight"},
    { dynamic : DynamicContentEnum.PAGESECTION, strapi : "general.page-section"},
    { dynamic : DynamicContentEnum.PANEL_SECTION, strapi : "general.panel-section"},
    { dynamic: DynamicContentEnum.BADGELIST, strapi: "general.badge-list" },
    { dynamic: DynamicContentEnum.STYLED_TEXT_LIST, strapi: "general.styled-text-list" },
    { dynamic: DynamicContentEnum.INFOPAGEACCORDION, strapi: "general.info-page-accordion" },
    { dynamic: DynamicContentEnum.HERO_BANNER_TWO_COLUMNS, strapi: "general.hero-banner-two-columns" },
    { dynamic: DynamicContentEnum.BETBY_BANNER, strapi: "general.betby-banner" },
    { dynamic: DynamicContentEnum.GAMESLIDER, strapi: "casino.game-slider" },
];
export const DynamicContentView = (
    props : {
        dynamicContent?: BaseContent[];
        infoPageId?: string;
        loggedIn?: boolean;
        isFooter?: boolean;
        country? : string,
        activeCurrency? : string;
    }) => {
    const dispatch = useDispatch();
    const [mobile, setMobile] = useState(window.innerWidth <= WindowSize.WIDTH_LG);
    const [heightAccordion, setHeightAccordion] = useState(0);

    const resize = () => {
        if(window.innerWidth <= WindowSize.WIDTH_LG) {
            setMobile(true);
        } else {
            setMobile(false);
        }

        const cardBodyClass = document.querySelectorAll<HTMLElement>('.expandable-accordion.expanded');
        for (let i = 0; i < cardBodyClass.length; i++) {
            const heightExpanded = cardBodyClass[i].scrollHeight
            setHeightAccordion(heightExpanded);

            if(cardBodyClass[i].style.height != `auto`) {
                cardBodyClass[i].style.height = `auto`
                cardBodyClass[i].style.maxHeight = `${heightExpanded}px`
            } else {
                const heightExpanded = cardBodyClass[i].scrollHeight
                cardBodyClass[i].style.height = `${heightAccordion}px`
                cardBodyClass[i].style.maxHeight = `${heightExpanded}px`
            }
        }

    }
    useEffect(()=>{
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        }
    },[dispatch])
    const handleClickAccordion = (infoPageId: any, index: any) => {
        const cardBodies = document.querySelectorAll<HTMLElement>('.expandable-accordion')
        const cardBody = document.getElementById(`expandable-${infoPageId}-${index}`)
        const styleHeight = cardBody && getComputedStyle(cardBody).height;
        const arrow = document.querySelectorAll<HTMLElement>('.arrow-accordion')
        const arrowId = document.getElementById(`arrow-${index}`)

        cardBodies.forEach(function(div) {
            if (div.id === (cardBody && cardBody.id)) {
                if(styleHeight == "0px") {
                    const scrollHeight = div.scrollHeight;
                    div.style.height = `${scrollHeight}px`
                    div.style.visibility = 'visible'
                    div.style.maxHeight = `${scrollHeight}px`
                    div.classList.add('expanded')
                } else if (styleHeight != "0px") {
                    div.style.height = '0px'
                    div.style.visibility = 'hidden'
                    div.style.maxHeight = '0px'
                    div.classList.remove('expanded')
                }

            } else {
                div.style.height = '0px'
                div.style.visibility = 'hidden'
                div.style.maxHeight = '0px'
                div.classList.remove('expanded')
            }

        });

        arrow.forEach(function(div) {
            if(div.id === (arrowId && arrowId.id)) {
                if(styleHeight == "0px") {
                    div.classList.add('show')
                } else if (styleHeight != "0px") {
                    div.classList.remove('show')
                }
            } else {
                div.classList.remove('show')
            }
        });
    }

    if(props.dynamicContent != undefined && props.dynamicContent.length > 0) {
        let result = props.dynamicContent.map((section, index) => {
            if(section === undefined) {
                console.error("section is undefined, will skip, while rendering content, index = %s: %o", index, props.dynamicContent)
                return <></>;
            }
            let contentType = section._contentType;
            if(!contentType) {
                // not in contentful, check strapi
                contentType = STRAPI_DYNAMIC_CONTENT_MAP.find(c => c.strapi === section.__component)?.dynamic;
                //console.log("Found content = ", contentType, section.__component);
            }
            if(!contentType) {
                console.warn("unable to render section, content type is null: section = %o", section)
                return <></>;
            }

            switch (contentType) {
                case DynamicContentEnum.GAMESLIDER:
                    return <GamesSlider key={index} mobile={mobile} section={section as GamesSliderProps}/>
                case DynamicContentEnum.PANEL_SECTION:
                    if((section as PageSection).type === "carousel") {
                        return <CarouselPanelComponent key={index} section={section as PanelSection}/>
                    } else {
                        return <PanelSectionComponent key={index} mobile={mobile} section={section as PanelSection} />
                    }
                case DynamicContentEnum.BETBY_BANNER:
                    return <BetByBannerWrapper key={index} section={section as BetbyBanner} />
                case DynamicContentEnum.BADGELIST:
                    return <Badges key={index} mobile={mobile} section={section as BadgeList} />
                case DynamicContentEnum.HERO_BANNER_TWO_COLUMNS:
                    return <HeroBannerTwoColumnsComponent key={index} mobile={mobile} section={section as HeroBannerTwoColumns} loggedIn={props.loggedIn} isFooter={props.isFooter} />
                case DynamicContentEnum.STYLED_TEXT_LIST:
                    return <StyledTextListComponent key={index} mobile={mobile} section={section as StyledTextList} loggedIn={props.loggedIn}/>
                case DynamicContentEnum.PAGESECTION :
                    return <PageSectionComponent key={index} mobile={mobile} section={section as PageSection} />
                case DynamicContentEnum.SECTIONBOXES :
                    return <SectionBoxesComponent key={index} mobile={mobile} section={section as SectionBoxes} />
                case DynamicContentEnum.INFOPAGEACCORDION :
                    return <InfoPageAccordionComponent key={index} mobile={mobile}
                                                       section={section as InfoPageAccordion}
                                                       infoPageId={props.infoPageId}
                                                       onClick={() => handleClickAccordion(props.infoPageId, index)}
                                                       index={index}
                    />
                case DynamicContentEnum.GAMELISTSECTION :
                    let sec = section as GameListSection;
                    let promoLength = (sec.listOfGamePromo ?? []).length;
                    if(promoLength > 0 || !sec.categoryId){
                        return <GameListSectionComponent key={index} mobile={mobile} section={sec} />
                    } else {
                        return <CategoryGameListSectionComponent key={index}  mobile={mobile} section={sec} />
                    }
                case DynamicContentEnum.GAMESPOTLIGHT :
                    return <GameSpotlightComponent key={index} mobile={mobile} section={section as GameSpotlight} />
                case DynamicContentEnum.BANNER_CAROUSEL:
                    return <BannerCarouselComponent key={index} section={section as BannerCarousel}/>
                default:
                    console.warn("Missing Contentful model renderer for model type: ", section._contentType);
                    return <></>;
            }
        })
        return <>{result}</>

    } else {
        return <></>;
    }
}
export default DynamicContentView;